module.exports = __webpack_public_path__ + "img/homeImpactForest.d3d8c971.svg";